import { Divider, Stack } from '@mantine/core';
import DailyUpdSigning from '@/components/app/deals/steps/forwarding/DailyUpdSigning';
import DealDocsByDay from '@/components/app/deals/steps/forwarding/DealDocsByDay';
import DealVehicleDocs from '@/components/app/deals/steps/forwarding/DealVehicleDocs';
import type { BargainStepsInfo } from '@/types/deals';

interface ForwardingDocsTabProps {
  readonly info: BargainStepsInfo;
  /** Живой шаг → доступно действие подписи УПД. В read-only отсутствует. */
  readonly dealId?: number;
}

// Вкладка «Документы»: «Подпись УПД» (важное действие) → «Документы по дням» (РТС, реестры, справки,
// расписки) → «По машинам» (ТТН/ТРН по каждому ТС, скачивание).
export default function ForwardingDocsTab({ info, dealId }: ForwardingDocsTabProps) {
  return (
    <Stack gap="lg">
      <DailyUpdSigning info={info} dealId={dealId} />
      <Divider />
      <DealDocsByDay documents={info.documents} />
      <Divider />
      <DealVehicleDocs info={info} />
    </Stack>
  );
}
